import { MotifsState } from './types';
import { Motifs } from './Motifs';
import { Motif } from './Motif';
import { Module, MutationTree, ActionTree, GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { getMotifs, getMotifsDuMoment, getListeCategories } from '@/services/api/motifs/api';
import _ from 'lodash';
import Fuse, { FuseOptions } from 'fuse.js';

const namespaced: boolean = true;

export const state: MotifsState = {
	motifs: undefined,
	motifsDuMoment: undefined,
	listeCategories: undefined,
	errorMotifs: false,
	loadedMotifs: false,
	errorMotifsDuMoment: false,
	loadedMotifsDuMoment: false,
	errorListeCategories: false,
	loadedListeCategories: false,
	fuseLibelle: '',
	fuseAcronymes: '',
	fuseRefSynonymes: '',
	fuseNotAllMatch: ''
};

export const mutations: MutationTree<MotifsState> = {
	updateMotifs(state: MotifsState, motifs: Motifs): void {
		state.motifs = motifs;
	},
	updateErrorMotifs(state: MotifsState, errorMotifs: boolean): void {
		state.errorMotifs = errorMotifs;
	},
	updateLoadedMotifs(state: MotifsState, loadedMotifs: boolean): void {
		state.loadedMotifs = loadedMotifs;
	},
	updateMotifsDuMoment(state: MotifsState, motifsDuMoment: Motifs): void {
		state.motifsDuMoment = motifsDuMoment;
	},
	updateErrorMotifsDuMoment(state: MotifsState, errorMotifsDuMoment: boolean): void {
		state.errorMotifsDuMoment = errorMotifsDuMoment;
	},
	updateLoadedMotifsDuMoment(state: MotifsState, loadedMotifsDuMoment: boolean): void {
		state.loadedMotifsDuMoment = loadedMotifsDuMoment;
	},
	updateListeCategories(state: MotifsState, listeCategories: string[]): void {
		state.listeCategories = listeCategories;
	},
	updateErrorListeCategories(state: MotifsState, errorListeCategories: boolean): void {
		state.errorListeCategories = errorListeCategories;
	},
	updateLoadedListeCategories(state: MotifsState, loadedMotifs: boolean): void {
		state.loadedMotifs = loadedMotifs;
	},
	updateFuseLibelle(state: MotifsState, fuseLibelle: string): void {
		state.fuseLibelle = fuseLibelle;
	},
	updateFuseAcronymes(state: MotifsState, fuseAcronymes: string): void {
		state.fuseAcronymes = fuseAcronymes;
	},
	updateFuseRefSynonymes(state: MotifsState, fuseRefSynonymes: string): void {
		state.fuseRefSynonymes = fuseRefSynonymes;
	},
	updateFuseNotAllMatch(state: MotifsState, fuseNotAllMatch: string): void {
		state.fuseNotAllMatch = fuseNotAllMatch;
	}
};

export const actions: ActionTree<MotifsState, RootState> = {
	fetchMotifs(state): Promise<void> {
		return new Promise((resolve, reject) => {
			return getMotifs()
				.then((response: any) => {
					const listeMotifs: Motif[] = _.get(response, 'data.value.listeMotifs');
					const motifs: Motifs = new Motifs({ listeMotifs });
					state.commit('updateMotifs', motifs);
					state.commit('updateLoadedMotifs', true);
					state.commit('updateFuseLibelle', new Fuse(listeMotifs, optionsLibelle));
					state.commit('updateFuseAcronymes', new Fuse(listeMotifs, optionsAcronymes));
					state.commit('updateFuseRefSynonymes', new Fuse(listeMotifs, optionsRefSynonymes));
					state.commit('updateFuseNotAllMatch', new Fuse(listeMotifs, optionsNotAllMatch));
					resolve();
				})
				.catch((error: any) => {
					state.commit('updateLoadedMotifs', true);
					state.commit('updateErrorMotifs', true);
					reject();
				});
		});
	},
	fetchMotifsDuMoment(state): Promise<void> {
		return new Promise((resolve, reject) => {
			return getMotifsDuMoment()
				.then((response: any) => {
					const listeMotifs: Motif[] = _.get(response, 'data.value.listeMotifsDuMoment');

					if (!_.isNil(listeMotifs)) {
						listeMotifs.forEach((motif) => {
							motif.libelle = motif.libelleCourt;
						});
					}

					const motifsDuMoment: Motifs = new Motifs({ listeMotifs });
					state.commit('updateMotifsDuMoment', motifsDuMoment);
					state.commit('updateLoadedMotifsDuMoment', true);
					resolve();
				})
				.catch((error: any) => {
					state.commit('updateLoadedMotifsDuMoment', true);
					state.commit('updateErrorMotifsDuMoment', true);
					reject();
				});
		});
	},
	fetchListeCategories(state): Promise<void> {
		return new Promise((resolve, reject) => {
			return getListeCategories()
				.then((response: any) => {
					const listeCategories: string[] = _.get(response, 'data.value.listeCategories');

					state.commit('updateListeCategories', listeCategories);
					state.commit('updateLoadedListeCategories', true);
					resolve();
				})
				.catch((error: any) => {
					state.commit('updateLoadedListeCategories', true);
					state.commit('updateErrorListeCategories', true);
					reject();
				});
		});
	}
};

export const getters: GetterTree<MotifsState, RootState> = {
	getMotifs(state) {
		return state.motifs;
	},
	getErrorMotifs(state) {
		return state.errorMotifs;
	},
	getLoaded(state) {
		return state.loadedMotifs;
	},
	getMotifsDuMoment(state) {
		return state.motifsDuMoment;
	},
	getErrorMotifsDuMoment(state) {
		return state.errorMotifsDuMoment;
	},
	getLoadedMotifsDuMoment(state) {
		return state.loadedMotifsDuMoment;
	},
	getListeCategories(state) {
		return state.listeCategories;
	},
	getErrorListeCategories(state) {
		return state.errorListeCategories;
	},
	getLoadedListeCategories(state) {
		return state.loadedListeCategories;
	},
	getFuseLibelle(state) {
		return state.fuseLibelle;
	},
	getFuseAcronymes(state) {
		return state.fuseAcronymes;
	},
	getFuseRefSynonymes(state) {
		return state.fuseRefSynonymes;
	},
	getFuseNotAllMatch(state) {
		return state.fuseNotAllMatch;
	}
};

export const motifs: Module<MotifsState, RootState> = {
	namespaced,
	state,
	getters,
	actions,
	mutations
};

const optionsLibelle: FuseOptions<Motif> = {
	shouldSort: true,
	tokenize: true,
	matchAllTokens: true,
	findAllMatches: true,
	includeScore: true,
	threshold: 0.2,
	location: 0,
	distance: 100,
	maxPatternLength: 50,
	minMatchCharLength: 2,
	keys: [
		'ref'
	]
};

const optionsAcronymes: FuseOptions<Motif> = {
	includeScore: true,
	shouldSort: true,
	threshold: 0,
	keys: ['acronymes']
};

const optionsRefSynonymes: FuseOptions<Motif> = {
	includeScore: true,
	shouldSort: true,
	tokenize: true,
	matchAllTokens: true,
	findAllMatches: true,
	threshold: 0.2,
	location: 0,
	distance: 100,
	maxPatternLength: 50,
	minMatchCharLength: 3,
	keys: [{
		name: 'refSynonymes',
		weight: 0.3
	}]
};

const optionsNotAllMatch: FuseOptions<Motif> = {
	includeScore: true,
	shouldSort: true,
	tokenize: true,
	threshold: 0.2,
	location: 0,
	distance: 100,
	maxPatternLength: 50,
	minMatchCharLength: 3,
	keys: [
		'ref'
	]
};
